import { render, staticRenderFns } from "./ProProfileBPage.vue?vue&type=template&id=f1cdfa26"
import script from "./ProProfileBPage.vue?vue&type=script&lang=js"
export * from "./ProProfileBPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports